import React from 'react';

interface SubheadingFormGroupProps {
    text: string;
}

const SubheadingFormGroup: React.FC<SubheadingFormGroupProps> = ({ text }) => (
    <div style={{ gridColumn: '1/6', fontSize: 23 }}>
        <strong>{text}</strong>
    </div>
);

export default SubheadingFormGroup;
